<div class="flex flex-col justify-between min-h-screen p-4 container">
    <div class="flex flex-col items-center justify-center">
        <!-- intro -->
        <div class="flex flex-row my-16">
            <img src="/assets/car.svg" class="h-20"/>
            <div class="h-20 w-px bg-black block mx-6"></div>
            <div class="font-medium text-xl leading-tight">Willkommen,<br /><span class="font-normal text-base">melden Sie sich an<br />um fortzufahren.</span></div>
        </div>
        <!-- help -->
        <h1 class="text-2xl font-medium mb-2">Passwort zurücksetzen</h1>
        <div class="text-center text-gray-700 text-sm mb-4">Geben Sie Ihre E-Mail Adresse ein, um Ihr Passwort zurückzusezten. Sie werden im Anschluss eine E-Mail erhalten, in welcher Sie Ihr neues Passwort setzen können.</div>
        <!-- reset -->
        <div class="flex flex-col w-full">
            <!-- mail -->
            <div class="flex flex-col mb-4">
                <label class="uppercase text-gray-700 font-medium text-xs mb-1">E-Mail Adresse <sup>*</sup></label>
                <input
                    class="appearance-none block border-2 border-gray-300 py-2 px-3 leading-tight focus:outline-none focus:border-primary-500 placeholder-gray-400"
                    [ngClass]="{'border-green-500': validMail === true, 'border-red-500': validMail === false}"
                    type="text"
                    [(ngModel)]="mail"
                    placeholder="mail@beispiel.de"
                    (blur)="validateMail()"
                />
            </div>
            <!-- error -->
            <div class="flex flex-row items-center justify-center mb-4 w-full bg-red-600 text-white px-4 py-2" *ngIf="error">
                <fa-icon [icon]="exclamationCircle"></fa-icon>
                <div class="h-4 w-px bg-white block mx-4"></div>
                <div>{{error}}</div>
            </div>
            <button
                class="btn btn-primary w-full"
                type="submit"
                (click)="resetPass($event)"
            >
                Zurücksetzen <fa-icon [icon]="longArrowRight"></fa-icon>
            </button>
            <!-- register link-->
            <span class="text-sm text-center mt-4">
                Erneut versuchen?
                <a class="text-primary-500 hover:text-primary-700 focus:underline focus:outline-none" [routerLink]="['']">
                    Anmelden
                </a>
            </span>
        </div>
    </div>
    <app-legal></app-legal>
</div>